import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fs-8 text-uppercase text-muted mb-1" }
const _hoisted_2 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right fs-9" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleGroups, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.field,
        class: "mb-3"
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(group.label), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.values, (value) => {
            return (_openBlock(), _createElementBlock("span", {
              key: value,
              class: "badge badge-light d-inline-flex align-items-center gap-1"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-gray-800 text-hover-primary",
                onClick: _withModifiers(($event: any) => (_ctx.$emit('filter', group.field, value)), ["prevent"])
              }, _toDisplayString(value), 9, _hoisted_3),
              (_ctx.externalLink(group.field, value))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.externalLink(group.field, value) || undefined,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "text-muted",
                    title: "Abrir referência externa"
                  }, _hoisted_6, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    }), 128)),
    (_ctx.collapsed && _ctx.groups.length > _ctx.previewCount)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          class: "fs-8 text-muted",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('expand')), ["prevent"]))
        }, "+" + _toDisplayString(_ctx.groups.length - _ctx.previewCount) + " grupos", 1))
      : _createCommentVNode("", true)
  ]))
}